import { format, isSameMonth } from "date-fns";
import { daysIn, fmtTime, rangeFor, ymd, THEME } from "@/lib/calendar";

export const MonthGrid = ({ anchor, eventsByDate, today, variant, onPickDay, audience }) => {
  const t = THEME[variant];
  const days = daysIn(rangeFor("month", anchor));
  return (
    <div data-testid="calendar-month-grid">
      <div className={`grid grid-cols-7 text-center text-xs font-semibold uppercase tracking-wide mb-1 ${t.muted}`}>
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d} className="py-1">{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {days.map((d) => {
          const key = ymd(d);
          const evs = eventsByDate[key] || [];
          const unassigned = audience === "dispatch" && evs.some((e) => e.unassigned);
          return (
            <button
              key={key}
              type="button"
              onClick={() => onPickDay(d)}
              className={`min-h-[64px] sm:min-h-[96px] rounded-lg border p-1 text-left transition-colors duration-150 ${t.sub} ${t.hover} ${isSameMonth(d, anchor) ? "" : "opacity-40"} ${key === today ? "ring-2 ring-cyan-500" : ""}`}
              data-testid={`calendar-day-${key}`}
            >
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold">{format(d, "d")}</span>
                {evs.length > 0 && (
                  <span className={`text-[10px] font-bold px-1.5 rounded-full ${unassigned ? "bg-red-500 text-white" : "bg-cyan-600 text-white"}`}>{evs.length}</span>
                )}
              </div>
              <div className="hidden sm:block mt-1 space-y-0.5">
                {evs.slice(0, 3).map((e) => (
                  <p key={e.id} className={`text-[10px] truncate ${e.unassigned && audience === "dispatch" ? "text-red-500 font-semibold" : ""}`}>
                    {fmtTime(e.time)} {e.leg === "return" ? "↩ " : ""}{e.client_name}
                  </p>
                ))}
                {evs.length > 3 && <p className={`text-[10px] ${t.muted}`}>+{evs.length - 3} more</p>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MonthGrid;
